/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { azureExpSwaggersToAzureExpStore } from 'src/core/handlers/azureExpMappers';
import { getAzureExpService } from 'src/core/services/azureExpService';
import { HandlerGroupFactoryDeps } from 'src/core/types/handler';
import { getPortalEnvironmentDomainName } from 'src/core/utils/routingUtils';

export type AzureExpHandlerGroup = ReturnType<typeof createAzureExpHandlerGroup>;

export const createAzureExpHandlerGroup = ({ rootStore, uiStore }: HandlerGroupFactoryDeps) => {
    const getAzureExpFeatureFlags = async () => {
        const { subscriptionId, csAccountStore } = rootStore.azureStore.session;

        const configsSwagger = await getAzureExpService().getFlightsConfigs({
            subscriptionId,
            resourceId: csAccountStore.id,
            resourceRegion: csAccountStore.region,
            resourceName: csAccountStore.name,
            portalLocale: uiStore.locale.code,
            portalEnvironment: getPortalEnvironmentDomainName()
        });

        const configsStore = azureExpSwaggersToAzureExpStore(configsSwagger);

        rootStore.setAzureExpStore(configsStore);
    };

    return { getAzureExpFeatureFlags };
};
